import { EmailEditorConfig, SystemEmailTemplate } from "model/SystemEmailTemplate";

export interface SystemEmailTemplatesState {
  list: Array<SystemEmailTemplate>;
  /** Single template loaded for preview/edit — `undefined` between sessions. */
  currentTemplate?: SystemEmailTemplate;
  /** Unlayer bootstrap config — `undefined` until first fetch. */
  unlayerConfig?: EmailEditorConfig;
  //
  loadingList: boolean;
  loadingTemplate: boolean;
  loadingConfig: boolean;
  saving: boolean;
  //
  status: SystemEmailTemplatesStatus;
}

export enum SystemEmailTemplatesStatus {
  Initial,
  FetchingList,
  FetchListSuccess,
  FetchingTemplate,
  FetchTemplateSuccess,
  FetchingConfig,
  FetchConfigSuccess,
  Saving,
  SaveSuccess,
  Error
}
